function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { useNui } from "../../../Theme/context";
import IconSpriggy from "../../../../themes/spriggy/iconSet/Action/Close.icon";
import IconNab from "../../../../themes/nab/iconSet/Action/Close.icon";
import IconKogan from "../../../../themes/kogan/iconSet/Action/Close.icon";
import IconJbwere from "../../../../themes/jbwere/iconSet/Action/Close.icon";
var CloseIcon = React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  var _useNui = useNui(),
      themeName = _useNui.themeName;

  var Component;

  switch (themeName) {
    case 'spriggy':
      Component = IconSpriggy;

    case 'nab':
      Component = IconNab;

    case 'kogan':
      Component = IconKogan;

    case 'jbwere':
      Component = IconJbwere;
  }

  return /*#__PURE__*/React.createElement(Component, _extends({
    color: color,
    size: size
  }, rest, {
    ref: ref
  }));
});

CloseIcon.toString = function () {
  return "CloseIcon";
};

export { CloseIcon };